import React from 'react';

import { Radio, RadioGroup } from './Radio'

const Status = (props) => {
    const list = props.statuses || []
    const disabled = props.disabled

    const options = list.map((item) => {
        let label = item.name
        if (item.description) {
            label = item.name + '<span style="opacity: 0.5; font-size: 12px;"> - ' + item.description + '</span>'
        }
        if (item.disabled || disabled) {
            label = '<span style="opacity: 0.5">' + label + '</span>'
        }
        return {
            key: item.id,
            value: item.id.toString(),
            label: label,
            disabled: item.disabled || disabled,
        }
    })
    
    return (
        <div className="form-group">
            <label className="col-sm-2 control-label">Status</label>
            <div className="col-sm-8">
                <RadioGroup
                    name={props.name}
                    value={props.value?.toString()}
                    onChange={(value) => props.onChange(parseInt(value, 10))}
                    options={options}
                />
            </div>
        </div>
    )
}
export default Status
